const semanticClassNames = {
  root: 'quick-action-bar',
} as const;

export default semanticClassNames;
